import {defineEnv, VariablesExport} from '@cosctl/environment';

export const variables = {
  // WorkOS configuration
  WORKOS_CLIENT_ID: defineEnv({
    key: 'PUBLIC_WORKOS_CLIENT_ID',
    default: '',
    description: 'WorkOS client ID',
  }),
  WORKOS_REDIRECT_URI: defineEnv({
    key: 'PUBLIC_WORKOS_REDIRECT_URI',
    default: 'http://localhost:4000/',
    description: 'WorkOS redirect URI',
  }),
} satisfies VariablesExport;
